import { render, staticRenderFns } from "./ProjectFileAttachStageTile.vue?vue&type=template&id=03ac79d2&scoped=true&lang=pug&"
import script from "./ProjectFileAttachStageTile.vue?vue&type=script&lang=js&"
export * from "./ProjectFileAttachStageTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileAttachStageTile.vue?vue&type=style&index=0&id=03ac79d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac79d2",
  null
  
)

export default component.exports